'use client'

import { CONFETTI_COLORS } from '@snowball-tech/common/constants'
import useViewportSize from '@snowball-tech/common/hooks/useViewportSize'

import Confetti from 'react-confetti'
import { createPortal } from 'react-dom'

import useHomeStore from '@/app/[locale]/(main)/(home)/store'

type Props = {
  forever?: boolean
  numberOfPieces?: number
}

export default function Confettis({
  forever = false,
  numberOfPieces = 400,
}: Props): false | ReturnType<typeof createPortal> {
  const [runConfettis, recycleConfettis] = useHomeStore((state) => [
    state.runConfettis,
    state.recycleConfettis,
  ])

  const { height = -1, width = -1 } = useViewportSize() ?? {}

  if (typeof document === 'undefined' || height <= 0 || width <= 0) {
    return false
  }

  return createPortal(
    <Confetti
      className={`!fixed top-0 !z-[10000] w-full`}
      colors={CONFETTI_COLORS}
      height={height}
      numberOfPieces={numberOfPieces}
      recycle={recycleConfettis || forever}
      run={runConfettis || forever}
    />,
    document?.body,
  )
}
